import { useState } from 'react'
import { useForm, usePage } from '@inertiajs/react'
import Layout from '../Layout'
import { useLocale } from '../../../lib/LocaleContext'

const INPUT_CLS =
  'w-full bg-zinc-800 border border-zinc-700 rounded px-3 py-2 text-sm font-mono text-zinc-100 ' +
  'placeholder-zinc-600 focus:outline-none focus:ring-2 focus:ring-emerald-500/40 focus:border-emerald-600'

const LABEL_CLS = 'block text-xs font-mono text-zinc-400 mb-1'

export default function Edit() {
  const { props } = usePage()
  const notice = props.flash?.notice
  const { t } = useLocale()

  const { data, setData, patch, processing, errors } = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
  })

  const [clientError, setClientError] = useState(null)

  function handleSubmit(e) {
    e.preventDefault()

    if (data.password !== data.password_confirmation) {
      setClientError(t('settings.password.mismatch'))
      return
    }

    setClientError(null)
    patch('/settings/password')
  }

  return (
    <Layout active="password">
      <div className="max-w-md">
        <h2 className="text-sm font-mono font-bold text-zinc-300 mb-6">{t('settings.password.title')}</h2>

        {notice && (
          <div className="mb-4 px-4 py-2 bg-emerald-950 border border-emerald-800 rounded-lg text-sm text-emerald-400 font-mono">
            {notice}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="current_password" className={LABEL_CLS}>{t('settings.password.current')}</label>
            <input
              id="current_password"
              type="password"
              value={data.current_password}
              onChange={e => setData('current_password', e.target.value)}
              className={INPUT_CLS}
              placeholder={t('settings.password.placeholder')}
              required
              autoFocus
            />
            {errors.current_password && (
              <p className="mt-1 text-xs font-mono text-red-400">{errors.current_password}</p>
            )}
          </div>

          <div>
            <label htmlFor="password" className={LABEL_CLS}>{t('settings.password.new')}</label>
            <input
              id="password"
              type="password"
              value={data.password}
              onChange={e => setData('password', e.target.value)}
              className={INPUT_CLS}
              placeholder={t('settings.password.placeholder')}
              required
            />
            {errors.password && (
              <p className="mt-1 text-xs font-mono text-red-400">{errors.password}</p>
            )}
          </div>

          <div>
            <label htmlFor="password_confirmation" className={LABEL_CLS}>{t('settings.password.confirm')}</label>
            <input
              id="password_confirmation"
              type="password"
              value={data.password_confirmation}
              onChange={e => setData('password_confirmation', e.target.value)}
              className={INPUT_CLS}
              placeholder={t('settings.password.placeholder')}
              required
            />
            {clientError && (
              <p className="mt-1 text-xs font-mono text-red-400">{clientError}</p>
            )}
            {errors.password_confirmation && (
              <p className="mt-1 text-xs font-mono text-red-400">{errors.password_confirmation}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={processing}
            className="bg-emerald-800/60 hover:bg-emerald-700/80 disabled:opacity-50 disabled:cursor-not-allowed text-emerald-200 border border-emerald-700/40 font-mono text-sm font-medium py-2 px-4 rounded-lg transition-colors"
          >
            {processing ? t('settings.password.submitting') : t('settings.password.submit')}
          </button>
        </form>
      </div>
    </Layout>
  )
}
